import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityCommonFilters, ProfitabilityOrderDetailResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilityOrderDetail = (
  orderId: number | undefined,
  filters: ProfitabilityCommonFilters | undefined,
  enabled = true
) => {
  return useQuery<ProfitabilityOrderDetailResponse, Error>({
    queryKey: ['profitability', 'order', orderId, filters],
    queryFn: () => adapter.getOrderById(orderId!, filters),
    enabled: Boolean(enabled && orderId != null && orderId > 0),
    staleTime: 60 * 1000,
  });
};
